import { createTheme } from '@mui/material'

export const textTheme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1725,
      },
    },
  });

export const mediaTheme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1390,
        xl: 1800,
      },
    },
});